import type { ToggleButtonPassThroughOptions } from "primevue/togglebutton";

export const togglebutton: ToggleButtonPassThroughOptions = {
  root: {
    class: [
      "relative",

      // Alignment
      "inline-flex",
      "align-bottom",

      // Misc
      "cursor-pointer",
      "select-none"
    ]
  },
  content: ({ props }) => ({
    class: [
      // Alignments
      "items-center inline-flex flex-1 text-center align-bottom justify-center",

      // Sizes & Spacing
      "px-3 py-2 leading-none",

      // Shapes
      "rounded-lg",

      // Colors
      {
        "text-system-grey": !props.modelValue,
        "text-contrast-bitter-sweet bg-contrast-bitter-sweet bg-opacity-20":
          props.modelValue
      },

      // Invalid State
      { "border-red-500": props.invalid },

      // States
      {
        "hover:text-system-dark-grey": !props.modelValue && !props.disabled
      },

      // Transitions
      "transition-all duration-200",

      // Misc
      {
        "cursor-pointer": !props.disabled,
        "opacity-60 select-none pointer-events-none cursor-default":
          props.disabled
      }
    ]
  }),
  label: ({ props }) => ({
    class: [
      "text-center w-full",
      {
        "!font-semibold !text-sky-600 !bg-sky-300": props.modelValue
      }
    ]
  }),
  icon: ({ props }) => ({
    class: [
      "mr-2",
      {
        "text-surface-600": !props.modelValue,
        "text-white": props.modelValue
      }
    ]
  })
};
